import Smartview from 'widgets/smartviews/Smartview'
import { ExecuteOperationOnPipe, ModelProxyWithForm, ModelWithForm, ResetFormOnPipe, TriggerPipelineOnFormSubmit, useModelValue } from '@morningtrain/react-resources'
import * as Fields from 'support/fields'
import { Translation, Translator, useTranslation } from '@morningtrain/react-translations'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import { SubmitButton } from 'ui/buttons'
import { Pipeline } from '@morningtrain/react-helpers'
import DeleteModelOnClick from 'support/actions/generic/DeleteModelOnClick'
import Button from 'ui/buttons/Button'
import React from 'react'
import ButtonWrap from 'ui/layouts/ButtonWrap'
import { Fieldset } from 'layouts/index'
import { Can } from '@morningtrain/react-auth'

export function EditAmoMemberSmartview ({ create = false }) {
  const type_placeholder = useTranslation('hr.amo.members.fields.type.placeholder')
  const user_placeholder = useTranslation('hr.amo.members.fields.user_id.placeholder')

  return (
    <Translator namespace='hr.amo.members'>
      <Smartview header={<Translation name={create ? 'create.title' : 'edit.title'} />}>
        <ModelProxyWithForm namespace='api' resourceName='amo.amo_member' parameterKeyName='amo_member'>
          {create ? <ResetFormOnPipe /> : null}
          <Fieldset cols={1}>
            <Fields.ResourceSelector
              resourceName='users.users'
              operationName='select'
              name='user_id'
              optionsKey='name'
              placeholder={user_placeholder}
              label={<Translation name='fields.user_id.label' />}
            />
            <Fields.Select
              enum='amo_member_type'
              name='type'
              placeholder={type_placeholder}
              label={<Translation name='fields.type.label' />}
            />
            <Fields.ResourceSelector
              resourceName='departments'
              operationName='select'
              name='departments'
              optionsKey='name'
              multiple
              label={<Translation name='fields.departments.label' />}
            />
          </Fieldset>
          <SmartviewContentSeparator />
          <ButtonWrap>
            {create ? null : (
              <Can permission='api.amo.amo_member.delete'>
                <DeleteModelOnClick resourceName='amo.amo_member' modelKey='user.name' resetSmartview>
                  <Button><Translation name='actions.delete' /></Button>
                </DeleteModelOnClick>
              </Can>
            )}

            <SubmitButton>
              <Translation name={create ? 'create.actions.save' : 'edit.actions.save'} />
            </SubmitButton>

            <Pipeline>
              <TriggerPipelineOnFormSubmit />
              <ExecuteOperationOnPipe operationName='index' />
            </Pipeline>
          </ButtonWrap>
        </ModelProxyWithForm>
      </Smartview>
    </Translator>
  )
}
